$(function(){
  // openZoom();
  cartDrawerUpt();
  // setInterval(function(){
    
  // },3000);
  masterPromo(false);

  $(document).on('cart:refresh', function() {
    console.log('cart refresh');
    setTimeout(() => {
      masterPromo(false);
    }, 1000);
  });

  $(document).on('cart:change', function() {
    console.log('cart change');
    setTimeout(() => {
      masterPromo(false);
    }, 1000);
  });
  
  document.addEventListener('cart:updated', function(evt) {
    masterPromo(false);
  });
  // $(document).on('cart.requestComplete', function(event, cart) {
  //   document.dispatchEvent(new CustomEvent('cart:build'));
  //   setTimeout(function(){
  //     if ($('.cart__items[data-count="0"]').length > 0) {
  //       location.reload();
  //     }
  //   },1000);
  // });
  document.addEventListener('ajaxProduct:added', function(evt) {
    masterPromo(false);
  });
  onloadMulticolumnHover();
  onclickGwp();
  onclickRemoveGwp();
  onloadUpdateGwp();
  pdpClickVariant();
  onloadUpdateVarImage();
  onloadSubscriptionBenefit();
  onloadUpdateImgGallery();
  onloadNewNavHover();
  cartSubscriptionNote();
  checkMultiGWP();
  setupVariantOption();
  controlVariantOption();
  onloadMultiColumnFlickity();
  setupMultiColumnIntersectionObserver();

  if (location.href.includes('/products')) {
    onloadUpdateButtonPrice();
  }
});

cartDrawerUpt = () => {
  $(document).on('cart.requestStarted', function(event, cart) {
    var $html = `<div class="jsc-page-loading">
                  <div class="jsc-spinner-container">
                    <div class="jsc-loading-text">Updating your cart...</div> 
                  </div>
                </div>`;
    $('body').prepend($html);
  });
  // $(document).on('cart.requestStarted', function(event, cart) {
  //   var $html = `<div class="jsc-page-loading">
  //                 <div class="jsc-spinner-container">
  //                   <div class="jsc-spinner"></div>
  //                 </div>
  //               </div>`;
  //   $('body').prepend($html);
  // });
  $(document).on('cart.requestComplete', function(event, cart) {
    // $('.jsc-page-loading').remove();
    setTimeout(function(){
      location.reload();
    },1200);

  });
}

masterPromo = (isDrawer) =>{
// removeTierGift();
gwpTierFunction(isDrawer);
cartGift();
  setTimeout(function(){
  },1000);
}

//Start GWP Tier promo
gwpTierFunction = (isOpenDrawer) =>{
console.log('gwpTierFunction');
// $.when($.getJSON('/cart.js', function(cart) {

// })).then(function(cart){
  var $deleteEle = $('.jsc-remove-gwp');

  if ($deleteEle.length > 0) { // remove previous tier product first
      $deleteEle.each(function() {
        var $vid = $(this).val();
        var $qty = 0;
        console.log('remove tier',$vid);
        cartJSUpdateQuery($vid, $qty, {}, false);
      });
  }
  else { // add current tier product after previous tier product is removed
    var $ele = $('._cartGwp');

    $ele.each(function() {
      var $gwpcart_product = {};
      var $vid = parseInt($(this).attr('data-vid'));
      var $tierNo = $(this).attr('data-tier');
      var $tierCol = $(this).attr('data-col');
      $gwpcart_product['GWP Tier '+$tierNo] = true;
      $gwpcart_product['_Cart_GWP'] = 'Free Gift';
      if ( $tierCol ) {
        $gwpcart_product['_GWP_col'] = $tierCol;
      }
      
      if ($(this).length > 0) {
        cartJSAddQuery($vid, 1, $gwpcart_product, false);
      }
    });
  }

// });

}
removeTierGift = () =>{
var $deleteEle = $('.jsc-remove-gwp');

if ($deleteEle.length > 0) {
    $deleteEle.each(function() {
      var $vid = $(this).val();
      var $qty = 0;
      console.log('remove tier',$vid);
      cartJSUpdateQuery($vid, $qty, {}, false);
    });
}

}
//End GWP Tier promo

//start: gwp
cartGift = () =>{
  addCartGift();
  removeCartGift();
  addStackableCartGift();
  removeStackableCartGift();
}

addCartGift = () =>{
  var $elem = $('#jsc-cart-gift');
  var $vid = $elem.val();
  var $obj = {};
  var $promoNo = $elem.attr('data-promo');
  var removeGift = sessionStorage.getItem("FreeGift");
  var $elem_wsl = $('.jsc-cart-gift-wsl');
  var $vid_wsl = $elem_wsl.val();

  //console.log($vid);

  if ( $elem_wsl.length > 0) {
    $obj['_Cart_Gift_WSL'] = $promoNo;
  }
  else {
    $obj['_Cart_Gift'] = $promoNo;
  }
  
  $obj['_Cart_GWP'] = 'Free Gift';
  if ($elem.length > 0 ) {
      if (removeGift != 'Remove') {
        console.log('add gwp');
      cartJSAddQuery($vid,1,$obj,true);
      }

  }

}

removeCartGift = () =>{
  var $elem = $('#jsc-cart-gift-remove');
  var $key = $elem.val();
  var $elem_wsl = $('.jsc-cart-gift-remove-wsl');
  var $key_wsl = $elem_wsl.val();

  if ($elem.length > 0) {
      cartJSUpdateQuery($key, 0, {}, true);
  }
  if ($elem_wsl.length > 0) {
    cartJSUpdateQuery($key_wsl, 0, {}, true);
}
}

addStackableCartGift = () =>{
  var _elem = $('.jsc-cart-gift-stackable');
  var _obj = {};

  _obj['_Cart_GWP'] = 'Free Gift';

  if (_elem.length > 0 ) {
    _elem.each(function(){
      var _this = $(this);
      var _promoNo = _this.attr('data-promo');
      var _vid = _this.val();

      _obj['_Cart_Gift_Stackable'] = _promoNo;

      cartJSAddQuery(_vid,1,_obj,true);
    });
  }
}

removeStackableCartGift = () =>{
  var _elem = $('.jsc-cart-gift-remove-stackable');

  if (_elem.length > 0) {
    _elem.each(function(){
      var _this = $(this);
      var _key = _this.val();
      
      cartJSUpdateQuery(_key, 0, {}, true);
    });
  }
}

removeFreeGift = (e,varID) =>{
  sessionStorage.setItem("FreeGift", "Remove");
  // var varID = $('#jsc-cart-gift').val();
  var varID = varID;
  //console.log(varID);
  cartJSUpdateQuery(varID, 0);
  $(document).on('cart.requestComplete', function(event, cart) {
  location.reload();
  });
}
onclickGwp = () => {

var tabs = document.getElementsByClassName("jsc-gwp-grid-atc cursor");
var closeBtn = document.getElementsByClassName("jsc-minus-close");
// cartJSUpdateQuery(44764225503445, 0, {}, true);

for (var i = 0; i < tabs.length; i++) {
  tabs[i].addEventListener("click", function() {
    // console.log('gwp click 1');
    $(this).addClass('jsc-not-allowed');
    $(this).removeClass('cursor');
    $(this).parents('.horizontal-product').siblings('.horizontal-product').find('.jsc-gwp-grid-atc ').removeClass('cursor');
    $(this).parents('.horizontal-product').siblings('.horizontal-product').find('.jsc-gwp-grid-atc ').addClass('jsc-not-allowed');

    var $gwpAdded = $(this).attr('data-gwp-added');
    var $vid = $(this).attr('data-prod-id');
    var $obj = {};
    var $promoNo = $(this).attr('data-promo');
    $(this).attr('data-gwp-added','true');

    $obj['_Cart_Gift_Manual'] = $promoNo;
    $obj['_Cart_GWP_Manual'] = 'Free Gift';
    if ($gwpAdded == 'false' ) {
        // if (removeGift != 'Remove') {
        // cartJSAddQuery($vid,1,$obj,true);
        // }
        $(this).find('.button').html('Added!');
        cartJSAddQuery($vid,1,$obj,true);
    }
  });
}
}
onclickRemoveGwp = () => {

var tabs = document.getElementsByClassName("jsc-gwp-remove-from-drawer");

var $elem = $('.jsc-cart-gift-manual-remove');
var $key = $elem.val();

if ($elem.length > 0) {
    cartJSUpdateQuery($key, 0, {}, true);
}
// cartJSUpdateQuery(44764225503445, 0, {}, true);

for (var i = 0; i < tabs.length; i++) {
  tabs[i].addEventListener("click", function() {
    var $key = $(this).attr('data-line-key');

    cartJSUpdateQuery($key, 0, {}, true);
  });
}
}
onloadUpdateGwp = () => {
//console.log('test2');
if (location.href.includes('/cart')) {
  var $enable_in_cartpage = $('.jsc-choose-gwp-container').attr('data-enable-in-cartpage');

  if ($enable_in_cartpage == 'true') {
    
  } else {
    $('.jsc-choose-gwp-container').hide();
  }
  // 
}
var tabs = document.getElementsByClassName("jsc-cart-drawer-quantity-input");
var removes = document.getElementsByClassName("jsc-cart-drawer-remove");
var pdp_atc = document.getElementsByClassName("product-info__buy-buttons");

for (var i = 0; i < tabs.length; i++) {
  tabs[i].addEventListener("input", function() {
    // This function will be called whenever an input value changes
    setTimeout(function(){
      location.reload()
    },1500);
  });
}

for (var i = 0; i < removes.length; i++) {
  removes[i].addEventListener("click", function() {
    // This function will be called whenever the remove button is clicked
    setTimeout(function(){
      location.reload()
    },1000);
  });
}
for (var i = 0; i < pdp_atc.length; i++) {
  pdp_atc[i].addEventListener("click", function() {
    // This function will be called whenever the remove button is clicked
    setTimeout(function(){
      location.reload()
    },3000);
  });
}
// setInterval(function(){
//   console.log('test');
//   $.when($.getJSON('/cart.js', function(cart) {
//     _totalPrice = cart.total_price;
//     _cartItems = cart.items;
//   })).then(function(){
//     for (var i = 0; i < _cartItems.length; i++) {
//       var _itemsKey = _cartItems[i].key;
//       var _itemsBindID = _cartItems[i].properties['_BindID'];
      
//     }
//   });
// },1000);
}

checkMultiGWP = () => {
  fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    var cartItems = cart.items;
    var removeList = {};
    
    for (var item of cartItems) {
      var properties = item.properties;
      var qty = item.quantity;
      var key = item.key;
      if ((properties['_Cart_GWP'] == 'Free Gift') && qty > 1) {
        removeList[key] = 1;
      }
    }

    if (Object.keys(removeList).length > 0) {
        cartJSUpdateQuantity(removeList);
    }
  });
}

//end: gwp

cartJSUpdateQuantity = (items) => {
    CartJS.updateItemQuantitiesById(items,
    {
      "success": function(data, textStatus, jqXHR) {
        $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          beforeSend: function() {
            console.log('before');
          },
          success: function(cart) {
            
          }
        });
      },
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", errorThrown);
      }
    });
}

cartJSAddQuery = (vid, qty, obj) => {
  // Cart js add item, success callback, error callback

  CartJS.addItem(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          console.log('before');
          // to call theme cart

        },
        success: function(cart) {
          /*
          getThis.element.dispatchEvent(new CustomEvent('product:added', {
            bubbles: isOpenDrawer,
            detail: {
              variant: vid,
              quantity: qty
            }
          }));
          */
        }
      });
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}

cartJSUpdateQuery = (vid, qty, obj, isOpenDrawer) => {
  // Cart js add item, success callback, error callback

  CartJS.updateItemById(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          console.log('before');
        },
        success: function(cart) {
          /*
          getThis.element.dispatchEvent(new CustomEvent('product:added', {
            bubbles: isOpenDrawer,
            detail: {
              variant: vid,
              quantity: qty
            }
          }));
          */
        }
      });
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}

//start: custom multicolumn hover image
onHoverDisplayText = (e) => {
console.log('jsc hover');
// $('body').css('background','red');
}

outHoverHideText = (e) => {
console.log('jsc done hover');
}
onloadMulticolumnHover = () => {
console.log('onload hover1',$(window).width());

if ($(window).width() > 799) {
  $('.jsc-multicolumn-block-image-container').hover(function(){
    // console.log($(window).width());
    $(this).find('.jsc-multicolumn-image-text-hover').removeClass('d-none');
    }, function(){
    $(this).find('.jsc-multicolumn-image-text-hover').addClass('d-none');
  });
}
else {
  //uncomment this if want to display 1 hover content at a time
  // $('.jsc-multicolumn-block-image-container').hover(function(){
  //   //do nothing
  //   }, function(){
  //   $(this).find('.jsc-multicolumn-image-text-hover').addClass('d-none');
  //   $(this).find('.jsc-tablet-down-hover-container .jsc-minus-close').addClass('d-none');
  //   $(this).find('.jsc-tablet-down-hover-container .jsc-plus-open').removeClass('d-none');
  // });
}

}
//end: custom multicolumn hover image
//start: open zoom
openZoom = () => {
var zoom = document.getElementsByClassName("ZoomHover");
for (var i = 0; i < zoom.length; i++) {
  zoom[i].addEventListener("click", function() {
    console.log($(this));
    $(this).addClass('active-tab');
    $(this).siblings('.product-gallery__zoom').find('button').click();
  });
}
}
//end: open zoom

//start: click variant pdp
pdpClickVariant = () => { //to update the price of variant selected
var zoom = document.getElementsByClassName("jsc-block-swatch");

for (var i = 0; i < zoom.length; i++) {
  zoom[i].addEventListener("click", function() {
          
    var $this_var_tab = $(this).parents('.product-info__variant-picker');
    setTimeout(function(){
      var $this_price_tab = $this_var_tab.siblings('.recharge-subscription-widget').find('.subscription-radio .price-label').text();

      if ($this_price_tab.length > 0) {
        $('.jsc-alt-price-pdp').text($this_price_tab);
        // console.log(this_price_tab);
      }

    },300);

  });
}

}
//end: click variant pdp

//start: update var image in product gallery
onloadUpdateVarImage = () => {
  // var $pageUrl = window.location.href;
  // var $currentVarId = $pageUrl.split('variant=')[1];
  var $selectedVar = $('.product-info__variant-picker').find('.variant-picker__option-values .jsc-selected-swatch');
  var mediaID = $selectedVar.attr('data-media-id');
  // alert(mediaID);
  var $media_gallery = $('.jsc-product-gallery__media');
  var $dummy_media_gallery = $('.jsc-dummy-main-image-div');

  if ($dummy_media_gallery.length > 0) {
    $media_gallery.each(function(){
      var $this_media_id = $(this).attr('data-media-id');
      if ($this_media_id == mediaID ) {
        
        var $this_src = $(this).find('.jsc-pdp-image').attr('src');
        var $this_srcset = $(this).find('.jsc-pdp-image').attr('srcset');
        // alert($this_srcset);
        
          $dummy_media_gallery.find('.jsc-pdp-image').attr('src',$this_src);
          $dummy_media_gallery.find('.jsc-pdp-image').attr('srcset',$this_srcset);
          // setTimeout(function(){},1000);
        
      }
    })
  }
}
jscUpdateVarImage = (e) => {
  // alert(mediaID);
  setTimeout(function() {
    const checkedInputs = $('input:checked[name^="option"]');
    let selector = '.jsc-variant-details';

    checkedInputs.each(function () {
      const name = $(this).attr('name');
      const value = $(this).val();
      selector += `[data-${name}="${value}"]`;
    });

    const $matchingVariant = $(selector);
    const matchedMediaId = $matchingVariant.attr('data-media-id');

    var $media_gallery = $('.jsc-product-gallery__media');
    var $dummy_media_gallery = $('.jsc-dummy-main-image-div');

    if ($dummy_media_gallery.length > 0) {
      $media_gallery.each(function(){
        var $this_media_id = $(this).attr('data-media-id');
        //$(this).removeClass('d-none');
        if ($this_media_id == matchedMediaId ) {
          //$(this).addClass('d-none');
          var $this_src = $(this).find('.jsc-pdp-image').attr('src');
          var $this_srcset = $(this).find('.jsc-pdp-image').attr('srcset');
          // alert($this_srcset);
          
          $dummy_media_gallery.find('.jsc-pdp-image').attr('src',$this_src);
          $dummy_media_gallery.find('.jsc-pdp-image').attr('srcset',$this_srcset);
          // setTimeout(function(){},1000);
          
        }
      })
    }
  }, 100);
}
//end: update var image in product gallery

//start: hide & show the subscription benefit in pdp
onloadSubscriptionBenefit = () => {
  var $subscription_benefit = $('.product-info__text.jsc-subscription-benefits');

  if ($subscription_benefit.length > 0) {

    setTimeout(function(){
      var $subscription_price = $('.rc-radio--active.subscription-radio');

      if ($subscription_price.length > 0) {
        $subscription_benefit.removeClass('d-none');
      } else {
        $subscription_benefit.addClass('d-none');
      }

      $('.rc-radio.onetime-radio').click(function(){
        $subscription_benefit.addClass('d-none');
      });
      $('.rc-radio.subscription-radio').click(function(){
        $subscription_benefit.removeClass('d-none');
      });

    },1000);
    
  }
}
//end: hide & show the subscription benefit in pdp

// start: new mega menu for Shop
jscMegaMenuTab = (e) => {
  var tab_siblings = $(e).siblings('.jsc-second-level-nav');
  tab_siblings.find('.is-active').removeClass('is-active'); //close other accordion

  var currentIsActive = $(e).find('.accordion__header').hasClass('is-active');
  $(e).find('> *').removeClass('is-active');

  if(currentIsActive != true) {
    $(e).find('.accordion__header').addClass('is-active');
    $(e).find('.accordion__body').addClass('is-active');
  }
}
// end: new mega menu for Shop

// start: rebuild image gallery in pdp
onloadUpdateImgGallery = () => {
  var $hidden_gallery_grid_status = $('.jsc-hidden-media-input').attr('data-split-variant');

  if ($hidden_gallery_grid_status == 'true') {
    if ($(window).width() > 799) {
      setTimeout(function(){
        $('.product-gallery__media-list').empty();
        var $hidden_gallery_grid = $('.jsc-hidden-media-input .jsc-hidden-media-each');
        var color = $('.jsc-option-Color').attr('data-option-val');
        var $media_sequence = 0;
        // alert(color);
        $hidden_gallery_grid.each(function(){
          var $this_media_alt = $(this).attr('data-media-alt');
          
          if ($this_media_alt == color) {
            $media_sequence += 1;
            $(this).clone().removeClass('jsc-hidden-media-each').addClass('product-gallery__media').attr('data-media-seq',$media_sequence).appendTo('.product-gallery__media-list');
          }
        });
      },100);
    } else {
      
    }
    
  }
  
}
jscClickColorVar = (e,color) => {
  if ($(window).width() > 799) {
    $('.product-gallery__media-list').empty(); //clear media carousel
    var $hidden_gallery_grid = $('.jsc-hidden-media-input .jsc-hidden-media-each');
    var $media_sequence = 0;

    $hidden_gallery_grid.each(function(){
      var $this_media_alt = $(this).attr('data-media-alt');
      if ($this_media_alt == color) {
        $media_sequence += 1;
        $(this).clone().removeClass('jsc-hidden-media-each').addClass('product-gallery__media').attr('data-media-seq',$media_sequence).appendTo('.product-gallery__media-list');
      }
    });
  } else {
    
  }
  
}
// end: rebuild image gallery in pdp

//start: product grid custom quick buy
var jscClickQuickBuy = (e) => {
  var variant_id = $(e).attr('data-var-id');
  var qty = 1;
  var selling_plan = $(e).attr('data-selling-plan');

  var data = {
    id: variant_id,
    quantity: qty,
    selling_plan: selling_plan,
  };
  
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      // Fetch the updated cart drawer section
      $.ajax({
        url: "/?section_id=cart-drawer",
        type: "GET",
        dataType: "html",
        success: function (carthtml) {
          // Update the cart drawer content
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer) {
            cartDrawer.innerHTML = $(carthtml).find("cart-drawer").html();
  
            // Open the cart drawer
            if (typeof cartDrawer.show === "function") {
              cartDrawer.show();
            }
          }

          // Update the cart count
          const cartCountElement = document.querySelector("cart-count");
          const updatedCount = $(carthtml).find("cart-count").text().trim();

          if (cartCountElement) {
            cartCountElement.textContent = updatedCount;
          }
          
          setTimeout(function(){
            masterPromo(false);
          },2000);
          
        },
        error: function () {
          console.error("Failed to fetch updated cart drawer content.");
        },
      });
    },
    error: function (xhr, status, error) {
      console.error("Error adding item to cart:", error);
    },
  });
  
}
var jscUpdateVarID = (e,variant_id,selling_plan) => {
  //console.log(variant_id);
  $(e).addClass('jsc-active-btn');
  $(e).siblings().removeClass('jsc-active-btn');
  var $custom_qb_btn = $(e).parents('.jsc-custom-qb-div').find('.jsc-custom-qb-button');
  $custom_qb_btn.attr('data-selling-plan',selling_plan);
  jscCloseCartDrawer();
}
var jscCloseCartDrawer = () => {
  
  setTimeout(() => {
    $('html').removeClass('lock');
  }, 1000);
    //console.log('close drawer');
}
var jscSelectVarID = (e) => {
  
  var selling_plan = $(e).val();
  if (selling_plan == 'One Time') {
    selling_plan = '';
  }
  else {
    
  }
  var $custom_qb_btn = $(e).parents('.jsc-custom-qb-div').find('.jsc-custom-qb-button');
  $custom_qb_btn.attr('data-selling-plan',selling_plan);
}
var jscSelectVarID_dropdown = (e) => {
  $(e).addClass('jsc-active-btn');
  $(e).siblings().removeClass('jsc-active-btn');
  setTimeout(function(){
    var selectedValue = $(e).val();
    //console.log('selectedValue',selectedValue);
    var $custom_qb_btn = $(e).parents('.jsc-custom-qb-div').find('.jsc-custom-qb-button');
    $custom_qb_btn.attr('data-selling-plan',selectedValue);
  },200);
  
}
//end: product grid custom quick buy

//start: show price in ATC button in pdp
var onloadUpdateButtonPrice = () => {
  var $pageUrl;
  var price;
  var activeLabel;
  var $subscription_radio;
  var $onetime_radio;
  var $subscription_widget = $('.recharge-subscription-widget');
  var $pdp_atc_btn;
  var $pdp_atc_btn_price;
  
  if ($subscription_widget.length > 0) {
    
    setInterval(function(){
      $pageUrl = window.location.href;
      //$pdp_atc_btn = $('.jsc-pdp-buy-buttons button div');

      $pdp_atc_btn_price = $('.product-info__buy-buttons .jsc-pdp-buy-buttons button div .jsc-pdp-btn-price');
      if ($pageUrl.includes("selling_plan")) {
        $subscription_radio = $subscription_widget.find("label.subscription-radio");
        activeLabel = $subscription_radio;
      } else {
        $onetime_radio = $subscription_widget.find("label.onetime-radio");
        activeLabel = $onetime_radio;
      }
      
      price = activeLabel.find('.price-label').html();
      $pdp_atc_btn_price.html(price);

      var $pdp_sticky_atc_subsc_plan;
      $pdp_sticky_atc_subsc_plan = $('.jsc-sticky-atc-subscription-plan');
      var $get_selling_plan_from_url = $pageUrl.split("selling_plan=")[1];
      var $get_selling_plan_from_form = $('.product-info__buy-buttons').find('input[name="selling_plan"]').val();
      
      if ($pdp_sticky_atc_subsc_plan.length > 0) {
        $pdp_sticky_atc_subsc_plan.find('.each-subs-plan').each(function(){
          var $this_selling_plan = $(this).attr('data-selling-plan');
          $(this).addClass('d-none');
          if ($this_selling_plan == $get_selling_plan_from_form) {
            $(this).removeClass('d-none');
          }
          //console.log($(this),$get_selling_plan_from_url,$this_selling_plan);
        });
      }

    },500);
    
  }
}
var jscUpdateButtonPrice = (e,price) => {
  var $pdp_atc_btn = $('.product-info__buy-buttons .jsc-pdp-buy-buttons button div'); 
  $pdp_atc_btn.find('.jsc-pdp-btn-dash').remove();
  $pdp_atc_btn.find('.jsc-pdp-btn-price').remove();

  setTimeout(function(){
    var $pageUrl = window.location.href;
    
    if ($pageUrl.includes("selling_plan")) {
      
      var $recharge_active_btn = $('.rc-radio--active');
      var $recharge_price = $recharge_active_btn.find('.price-label').html();
      //console.log("$recharge_active_btn",$recharge_price);
      price = $recharge_price;
    } else {
        
    }
    
    //$pdp_atc_btn.find('.jsc-pdp-btn-dash').remove();
    //$pdp_atc_btn.find('.jsc-pdp-btn-price').remove();
    $pdp_atc_btn.append('<span class="jsc-pdp-btn-dash"> - </span><span class="jsc-pdp-btn-price">' + price + '</span>');

    var $pdp_sticky_atc_subsc_plan;
    $pdp_sticky_atc_subsc_plan = $('.jsc-sticky-atc-subscription-plan');
    var $get_selling_plan_from_url = $pageUrl.split("selling_plan=")[1];
    var $get_selling_plan_from_form = $('.product-info__buy-buttons').find('input[name="selling_plan"]').val();
    
    if ($pdp_sticky_atc_subsc_plan.length > 0) {
      $pdp_sticky_atc_subsc_plan.find('.each-subs-plan').each(function(){
        var $this_selling_plan = $(this).attr('data-selling-plan');
        $(this).addClass('d-none');
        if ($this_selling_plan == $get_selling_plan_from_form) {
          $(this).removeClass('d-none');
        }
        console.log($(this),$get_selling_plan_from_url,$this_selling_plan);
      });
    }
  },200);
  
}

var updateQuickBuyPrice = (evt) => { 
  var $quickBuyInfo = $(evt).closest('.quick-buy-drawer'); 
  if ($quickBuyInfo.length > 0) { 
    setTimeout(() => { 
      var price = $quickBuyInfo.find('sale-price .money').text(); 
      var $atcBtn = $quickBuyInfo.find('.jsc-pdp-buy-buttons button div'); 
      $atcBtn.append('<span class="jsc-pdp-btn-dash"> - </span><span class="jsc-pdp-btn-price">' + price + '</span>'); 
    }, 200); 
  } 
} 
//end: show price in ATC button in pdp

//start: scroll to attached section 
var jscScrollToMainSection = (scrollTo) => {
  
  //var target = $('.jsc-product-page');
  var target = $("." + scrollTo);
  
  if (target.length) {
      $("html, body").animate({
          scrollTop: target.offset().top - 150 // Adjust for fixed header
          // scrollTop: target.offset().top - 150
      }, 800);
  }
  
}
//end: scroll to attached section
// start: section anchor
getAnchorLink = (e) => {
  var anchorLink = $(e).attr('data-anchor-id');
  scrollToSection(anchorLink);
}
scrollToSection = (link) => {
  var target = $('[data-anchor="' + link + '"]:first');
  if(target.length > 0) {
    var top = target.offset().top - 150;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }
}
// end: section anchor

//start: hover new navigation March 2025
onloadNewNavHover = () => {
  // console.log('onload hover navvvv');
  $('.jsc-second-level-nav-title a').hover(
    function(){ // run this when hover
      var $this_title = $(this).parent().attr('data-second-level-handle');
      var $this_tab = $(this).parent();
      var $other_tab = $(this).parent().siblings('.jsc-second-level-nav-title');
      var $this_thin_arrow = $(this).find('.jsc-menu-arrow-thin');
      var $this_bold_arrow = $(this).find('.jsc-menu-arrow-bold');
      //$this_thin_arrow.hide();
      //$this_bold_arrow.show();
      $other_tab.removeClass('jsc-active-second-nav');
      $this_tab.addClass('jsc-active-second-nav');

      $('.jsc-second-level-content').each(function(){
        var $this_parent_title = $(this).attr('data-second-level-handle')
        $(this).hide();
        //$this_tab.removeClass('jsc-active-second-nav');

        if ($this_parent_title == $this_title) {
          $(this).show();
          
        }
      });
    },
    function () { // run this when outhover
      var $this_title = $(this).attr('data-second-level-handle');
      var $this_thin_arrow = $(this).find('.jsc-menu-arrow-thin');
      var $this_bold_arrow = $(this).find('.jsc-menu-arrow-bold');
      //$this_thin_arrow.show();
      //$this_bold_arrow.hide();
      
      // $('.jsc-second-level-content').each(function(){
      //   $(this).hide();
      // });
      // $('.jsc-second-level-first-content').show();
    }
  );
}
//end: hover new navigation March 2025

cartSubscriptionNote = () => {
  const targetNode = document.querySelector('#cart-drawer');

  if (targetNode) {
    const config = { childList: true, subtree: true };

    const callback = function(mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          if (targetNode.querySelector('.jsc-subscription-label')) {
            $('.jsc-subscription-note').removeClass('d-none');
          } else {
            $('.jsc-subscription-note').addClass('d-none');
          }
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
}

//start: show or hide variant button
var setupVariantOption = () => {
  const inputs = $(`input[name="option1"]`);
  inputs.each(function () {
    const val = $(this).val();
    const option1 = $(`.jsc-variant-details:not(.jsc-hidden-variant)[data-option1="${val}"]`);
    
    if (option1.length === 0) {
      $(this).next('.jsc-block-swatch').addClass('jsc-block-swatch-hidden');
    }
  });
}
var controlVariantOption = () => {
  const hiddenVariants = $('.jsc-hidden-variant');

  if (hiddenVariants.length > 0) {
    setTimeout(function() {
      var variants = $('input:checked + .jsc-block-swatch'); //:not(.d-none)
      const selected = variants.map((_, el) => {
        const inputId = $(el).attr('for');
        return document.getElementById(inputId)?.value;
      }).get();
 
      // Reset visibility
      $('.jsc-block-swatch').removeClass('d-none');

      hiddenVariants.each(function () {
        const $hiddenVariant = $(this);

        for (let i = 0; i < selected.length; i++) {
          const optionAttr = $hiddenVariant.attr(`data-option${i + 1}`);
          
          if (optionAttr != selected[i] && i != selected.length - 1) {
            break;
          } else if (i == selected.length - 1) {
            const lastOptionValue = $hiddenVariant.attr(`data-option${selected.length}`);
            
            if (lastOptionValue == optionAttr) {
              const input = $(`input[value="${lastOptionValue}"] + .jsc-block-swatch`);
              input.addClass('d-none');
            }
          }
        }
      });

      // if there is any selected hidden variant, then reselect the first available option
      variants = $('input:checked + .jsc-block-swatch.d-none, input:checked + .jsc-block-swatch.jsc-block-swatch-hidden');
      variants.each(function() {
        const $variant = $(this);
        const inputId = $variant.attr('for');
        const $input = $('#' + inputId);
        const inputName = $input.attr('name');

        $(`input[name="${inputName}"] + .jsc-block-swatch:not(.d-none):not(.jsc-block-swatch-hidden)`).first().trigger('click');

        if (inputName == 'option1') {
          return false;
        }
      });
    }, 50);
  }
}
//end: show or hide variant button

//start: enable flickity for multicolumn section
var onloadMultiColumnFlickity = ($context) => {
  var $scope = $context ? $($context) : $(document);
  var $jsc_mobile_flickity = $scope.find('.jsc-multi-column-mobile-flickity').add($scope.filter('.jsc-multi-column-mobile-flickity'));
  var $jsc_desktop_flickity = $scope.find('.jsc-multi-column-desktop-flickity').add($scope.filter('.jsc-multi-column-desktop-flickity'));

  if ($jsc_mobile_flickity.length > 0) {
    
    if ($(window).width() < 480) {

      $jsc_mobile_flickity.each(function(){
        var $this = $(this);
        var $slide_limit = $this.attr('data-mobile-flky-limit');

        var flkty = new Flickity(this, {
          cellAlign: 'center',
          contain: true,
          pageDots: true,
          groupCells: $slide_limit,
          imagesLoaded: true,
          wrapAround: true,
          draggable: true,
          prevNextButtons: true,
          // autoPlay: 4000,
          on: {
            ready: function() {
              var self = this;

              if (typeof self.resize === 'function') {
                self.resize();
              }

              setTimeout(function () {
                if (typeof self.resize === 'function') self.resize();
                if (typeof self.reposition === 'function') self.reposition();
              }, 300);

              $($this).addClass('jsc-flickity-initiated');
            }
          }
        });
      });
    }
  }

  if ($jsc_desktop_flickity.length > 0) {
    
    if ($(window).width() > 481) {

      $jsc_desktop_flickity.each(function(){
        var $this = $(this);
        var $slide_limit = $this.attr('data-desktop-flky-limit');

        var flkty = new Flickity(this, {
          cellAlign: 'left',
          contain: true,
          pageDots: true,
          groupCells: $slide_limit,
          imagesLoaded: true,
          wrapAround: true,
          draggable: true,
          prevNextButtons: true,
          // autoPlay: 4000,
          on: {
            ready: function() {
              var self = this;

              if (typeof self.resize === 'function') {
                self.resize();
              }

              setTimeout(function () {
                if (typeof self.resize === 'function') self.resize();
                if (typeof self.reposition === 'function') self.reposition();
              }, 300);

              $($this).addClass('jsc-flickity-initiated');
            }
          }
        });
      });
    }
  }
}
//end: enable flickity for multicolumn section

var destroyMultiColumnFlickityInstances = ($elements) => {
  var destroyedCount = 0;

  if (typeof Flickity === 'undefined') {
    return destroyedCount;
  }

  $elements.each(function(){
    var instance = Flickity.data(this);

    if (instance) {
      instance.destroy();
      destroyedCount++;
    }

    $(this).removeClass('jsc-flickity-initiated');
  });

  return destroyedCount;
}

var refreshMultiColumnFlickity = ($context) => {
  var $scope = $context ? $($context) : $(document);

  if ($scope.length === 0) {
    return;
  }

  var $mobileCarousels = $scope.find('.jsc-multi-column-mobile-flickity').add($scope.filter('.jsc-multi-column-mobile-flickity'));
  var $desktopCarousels = $scope.find('.jsc-multi-column-desktop-flickity').add($scope.filter('.jsc-multi-column-desktop-flickity'));

  var destroyedMobile = destroyMultiColumnFlickityInstances($mobileCarousels.filter('.jsc-flickity-initiated'));
  var destroyedDesktop = destroyMultiColumnFlickityInstances($desktopCarousels.filter('.jsc-flickity-initiated'));
  var totalDestroyed = destroyedMobile + destroyedDesktop;

  var needsInit = $mobileCarousels.filter(':not(.jsc-flickity-initiated)').length > 0 || $desktopCarousels.filter(':not(.jsc-flickity-initiated)').length > 0;

  if (totalDestroyed > 0 || needsInit) {
    setTimeout(() => {
      onloadMultiColumnFlickity($scope);
    }, 50);
  }
}

var multiColumnSectionObserver = null;

var observeMultiColumnSections = ($sections) => {
  if (!multiColumnSectionObserver || !$sections || !$sections.length) {
    return;
  }

  $sections.each(function(){
    multiColumnSectionObserver.observe(this);
  });
}

var setupMultiColumnIntersectionObserver = () => {
  if (typeof window === 'undefined' || typeof window.IntersectionObserver === 'undefined') {
    return;
  }

  if (multiColumnSectionObserver) {
    multiColumnSectionObserver.disconnect();
  }

  multiColumnSectionObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        refreshMultiColumnFlickity($(entry.target));
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '0px 0px -100px 0px',
    threshold: 0.1
  });

  observeMultiColumnSections($('.shopify-section--multi-column'));
}

$(window).on('load', function() {
  refreshMultiColumnFlickity();
});

document.addEventListener('shopify:section:load', function(event) {
  var $section = $(event.target).closest('.shopify-section');
  if ($section.length) {
    refreshMultiColumnFlickity($section);
    observeMultiColumnSections($section.filter('.shopify-section--multi-column'));
  }
});

document.addEventListener('shopify:section:select', function(event) {
  var $section = $(event.target).closest('.shopify-section');
  if ($section.length) {
    refreshMultiColumnFlickity($section);
  }
});

//start: featured collection tab
var jscSwitchCollectionTab = (collectionId) => {
  $(`.jsc-collection-tab, .jsc-collection-link, .jsc-header-link`).addClass('d-none');
  $(`#jsc-collection-tab-${collectionId}, #jsc-collection-link-${collectionId}, #jsc-header-link-${collectionId}`).removeClass('d-none');
  $(`.jsc-collection-tab-header`).removeClass('active');
  $(`.jsc-collection-tab-header-${collectionId}`).addClass('active');
}
//end: featured collection tab